import React from 'react';
import { NavLink } from 'react-router-dom';
import classnames from 'classnames';

import { CollaboratorAvatar } from 'components';
import { CollaboratorAvatarSize } from 'helpers/constants';

import styles from './Profile.module.scss';

interface ProfileProps {
  avatarSize?: CollaboratorAvatarSize;
  className?: string;
  profile: {
    id: string;
    displayName: string;
    emailAddress: string;
    photoURL: string;
  };
  showGroups?: boolean;
  type?: string;
}

export const Profile: React.FC<ProfileProps> = ({ avatarSize, className, profile, type }) => {
  return (
    <div
      className={classnames(className, styles.profile, {
        [styles[`type-${type}`]]: type,
      })}
    >
      <NavLink className={styles.avatarLink} to={`/profile/${profile.id}`}>
        <CollaboratorAvatar collaborator={profile} size={avatarSize} bordered={false} />
      </NavLink>

      <div className={styles.meta}>
        <NavLink className={styles.avatarLink} to={`/profile/${profile.id}`}>
          <div className={styles.name}>{profile.displayName}</div>
        </NavLink>

        <div className={styles.email}>{profile.emailAddress}</div>
      </div>
    </div>
  );
};
